import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=26981e1d"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&id=26981e1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports